import { render, staticRenderFns } from "./AddSelfGoods.vue?vue&type=template&id=56bd58ab&scoped=true&"
import script from "./AddSelfGoods.vue?vue&type=script&lang=js&"
export * from "./AddSelfGoods.vue?vue&type=script&lang=js&"
import style1 from "../style.css?vue&type=style&index=1&id=56bd58ab&prod&scoped=true&lang=css&"
import style2 from "./AddSelfGoods.vue?vue&type=style&index=2&id=56bd58ab&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bd58ab",
  null
  
)

export default component.exports